module.exports = __webpack_public_path__ + "static/media/ahead-pb-logo.c8865457.svg";